function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

document.addEventListener(
  "BSS:eventCheckout",
  debounce((e) => {
    BSS_B2B.observer.cartSubject.notifyObserver("CartUpdate", "CartMutate");
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }, 300)
);

setTimeout(() => {
  function handleButtonClick(e) {
    e.preventDefault();
    const $button = $(this);
    let oldText = $(this).text();
    $button.css({ "pointer-events": "none", opacity: "0.6" });
    $button.text("Loading ...");

    setTimeout(() => {
      $button.css({ "pointer-events": "unset", opacity: "1" });
      $button.text(oldText);
    }, 2000);
  }

  $(document).on(
    "click dblclick",
    'button[name="checkout"]',
    handleButtonClick
  );
}, 500);

BSS_B2B.customTriggerCheckoutBtn = function () {
  window.location.href = "/checkout";
};

window.addEventListener("load", function () {
  let counter = 0;
  const interval = setInterval(() => {
    if ($(".bss-b2b-rf-field.field-country").length) {
      translateCountry();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);

  const targetNode = document.querySelector("cart-drawer");

  if (targetNode) {
    const callback = function (mutationsList) {
      console.log(mutationsList);
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open"
        ) {
          const isOpen = targetNode.hasAttribute("open");
          if (isOpen) {
            setTimeout(() => {
              if ($("cart-drawer .bss-b2b-tax-ex-wrapper").length === 0) {
                const teBox = document.querySelector(".bss-b2b-tax-ex-wrapper");
                if (!teBox) return;
                const teBoxClone = teBox.cloneNode(true);
                document
                  .querySelector("div[slot='footer']")
                  .insertAdjacentElement("afterbegin", teBoxClone);
              }
              BSS_B2B.observer.cartSubject.listenCartCheckout();
            }, 300);
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    const config = { attributes: true };
    observer.observe(targetNode, config);
  }
});

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

const isCartPage = window.location.pathname === "/cart";
let counter = 0;
let selector = "section:has(+footer):has(.bss-b2b-vat-input)";
const interval = setInterval(() => {
  if ($(selector).length > 0) {
    if (!isCartPage) {
      const teBox = document.querySelector(".bss-b2b-tax-ex-wrapper");
      const teBoxClone = teBox.cloneNode(true);
      document
        .querySelector("div[slot='footer']")
        .insertAdjacentElement("afterbegin", teBoxClone);
    } else {
      $(selector).remove();
    }
    $(".bss-b2b-vat-input").val(window.vatNumber);
    clearInterval(interval);
  } else {
    counter += 100;
    if (counter >= 10000) {
      clearInterval(interval);
    }
  }
}, 100);

let timeBack = 10;
const handleF = () => {
  const target = $("#bss-b2b-registration-form-render");
  if (target.length > 0) {
    setTimeout(() => {
      $(
        '#RegisterForm input:not([type="checkbox"]):not([type="file"]):not(.country-field):not([type="hidden"]):not([type="submit"])'
      ).each((_, input) => {
        $(input).attr("placeholder", " ");
        let label = $(input).parent().find("label");
        if (label.length == 0) label = $(input).parent().parent().find("label");
        $(input).parent().css("position", "relative");
        $(input).after(label);
      });
    }, 300);
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};
handleF();

function fixQueryArrInQbTotalPriceOfItemElement({ queryArr, key }) {
  return [
    '[data-cart-item-key="' + key + '"] price-list',
    '[data-cart-item-key="' + key + '"] .bss-final-price',
  ];
}
window.BSS_B2B.addFilter(
  "fix_queryArr_in_qb_totalPriceOfItemElement",
  fixQueryArrInQbTotalPriceOfItemElement
);

const handleCartCheckoutBtn = ({ shopData, checkoutButton, Tax }) => {
  BSS_B2B.isUsingBssCheckout = true;
  const defaultBtnCheckout = $(checkoutButton)
    .parent()
    .find("button[name='checkout']");
  if (defaultBtnCheckout.length > 0) {
    defaultBtnCheckout.css("display", "none");
    $("#bss-checkout").css("display", "block");
    $("button#bss-checkout").css("display", "block");
  }
};
window.BSS_B2B.addAction("fix_handle_cart_checkout_btn", handleCartCheckoutBtn);

BSS_B2B.isLoadingCheckout = false;
const handleBSSCheckout = () => {
  if (BSS_B2B.isUsingBssCheckout && !BSS_B2B.isLoadingCheckout) {
    console.log("handleBSSCheckout");
    BSS_B2B.isLoadingCheckout = true;
    BSS_B2B.observer.cartSubject.listenCartCheckout();
    setTimeout(() => {
      $("#bss-checkout").click();
    }, 300);
    setTimeout(() => {
      BSS_B2B.isLoadingCheckout = false;
    }, 3000);
  }
};

const loop = setInterval(() => {
  if ($(".bss-b2b-rf-submit-button .btn").length > 0) {
    $(".bss-b2b-rf-submit-button .btn").val("Registreer hier");
    $(".bss-b2b-rf-submit-button .btn").css({ "text-transform": "none" });
    clearInterval(loop);
  }
}, 100);
setTimeout(() => {
  clearInterval(loop);
}, 8000);

if (window.location.pathname === "/pages/zakelijk") {
  console.error(123);
  const loop3 = setInterval(() => {
    if ($(".bss-b2b-registration-form-title").length) {
      $(".bss-b2b-registration-form-title").after(
        `<p class="login-text">Heb je al een account? <a href='/account/login'>Log hier in</a></p>`
      );
      clearInterval(loop3);
    }
  }, 100);
  setTimeout(() => {
    clearInterval(loop3);
  }, 8000);
}

function translateCountry() {
  var countryNamesDutch = {
    AF: "Afghanistan",
    AX: "Ålandeilanden",
    AL: "Albanië",
    DZ: "Algerije",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AG: "Antigua en Barbuda",
    AR: "Argentinië",
    AM: "Armenië",
    AW: "Aruba",
    AC: "Ascension",
    AU: "Australië",
    AT: "Oostenrijk",
    AZ: "Azerbeidzjan",
    BS: "Bahama's",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Wit-Rusland",
    BE: "België",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivië",
    BA: "Bosnië en Herzegovina",
    BW: "Botswana",
    BV: "Bouvet eiland",
    BR: "Brazilië",
    IO: "Brits Indische Oceaangebied",
    VG: "Britse Maagdeneilanden",
    BN: "Brunei",
    BG: "Bulgarije",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodja",
    CM: "Kameroen",
    CA: "Canada",
    CV: "Kaapverdië",
    BQ: "Caribisch Nederland",
    KY: "Caymaneilanden",
    CF: "Centraal-Afrikaanse Republiek",
    TD: "Tsjaad",
    CL: "Chili",
    CN: "China",
    CX: "Kerstmis Eiland",
    CC: "Cocos (Keeling) Eilanden",
    CO: "Colombia",
    KM: "Comoren",
    CG: "Congo - Brazzaville",
    CD: "Congo - Kinshasa",
    CK: "Cookeilanden",
    CR: "Costa Rica",
    CI: "Ivoorkust",
    HR: "Kroatië",
    CU: "Cuba",
    CW: "Curaçao",
    CY: "Cyprus",
    CZ: "Tsjechië",
    DK: "Denemarken",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominicaanse Republiek",
    EC: "Ecuador",
    EG: "Egypte",
    SV: "El Salvador",
    GQ: "Equatoriaal-Guinea",
    ER: "Eritrea",
    EE: "Estland",
    SZ: "Eswatini",
    ET: "Ethiopië",
    FK: "Falklandeilanden",
    FO: "Faeröer",
    FJ: "Fiji",
    FI: "Finland",
    FR: "Frankrijk",
    GF: "Frans-Guyana",
    PF: "Frans-Polynesië",
    TF: "Franse Zuidelijke Gebieden",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgië",
    DE: "Duitsland",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Griekenland",
    GL: "Groenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinee",
    GW: "Guinee-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard- en McDonaldeilanden",
    HN: "Honduras",
    HK: "Hongkong SAR",
    HU: "Hongarije",
    IS: "IJsland",
    IN: "India",
    ID: "Indonesië",
    IR: "Iran",
    IQ: "Irak",
    IE: "Ierland",
    IM: "Isle of Man",
    IL: "Israël",
    IT: "Italië",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordanië",
    KZ: "Kazachstan",
    KE: "Kenia",
    KI: "Kiribati",
    XK: "Kosovo",
    KW: "Koeweit",
    KG: "Kirgizië",
    LA: "Laos",
    LV: "Letland",
    LB: "Libanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libië",
    LI: "Liechtenstein",
    LT: "Litouwen",
    LU: "Luxemburg",
    MO: "Macao SAR China",
    MG: "Madagaskar",
    MW: "Malawi",
    MY: "Maleisië",
    MV: "Maldiven",
    ML: "Mali",
    MT: "Malta",
    MQ: "Martinique",
    MR: "Mauritanië",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    MD: "Moldavië",
    MC: "Monaco",
    MN: "Mongolië",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Marokko",
    MZ: "Mozambique",
    MM: "Myanmar (Birma)",
    NA: "Namibië",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Nederland",
    AN: "Nederlands-Antillen",
    NC: "Nieuw-Caledonië",
    NZ: "Nieuw-Zeeland",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolkeiland",
    KP: "Noord-Korea",
    MK: "Noord-Macedonië",
    NO: "Noorwegen",
    OM: "Oman",
    PK: "Pakistan",
    PS: "Palestijnse Gebieden",
    PA: "Panama",
    PG: "Papoea-Nieuw-Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Filipijnen",
    PN: "Pitcairneilanden",
    PL: "Polen",
    PT: "Portugal",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Roemenië",
    RU: "Rusland",
    RW: "Rwanda",
    WS: "Samoa",
    SM: "San Marino",
    ST: "São Tomé en Príncipe",
    SA: "Saoedi-Arabië",
    SN: "Senegal",
    RS: "Servië",
    SC: "Seychellen",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten",
    SK: "Slovakije",
    SI: "Slovenië",
    SB: "Salomonseilanden",
    SO: "Somalië",
    ZA: "Zuid-Afrika",
    KR: "Zuid-Korea",
    SS: "Zuid-Soedan",
    ES: "Spanje",
    LK: "Sri Lanka",
    SD: "Soedan",
    SR: "Suriname",
    SJ: "Svalbard en Jan Mayen",
    SE: "Zweed",
    CH: "Zwitserland",
    SY: "Syrië",
    TW: "Taiwan",
    TJ: "Tadzjikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad en Tobago",
    TN: "Tunesië",
    TR: "Turkije",
    TM: "Turkmenistan",
    TC: "Turks- en Caicoseilanden",
    TV: "Tuvalu",
    UG: "Oeganda",
    UA: "Oekraïne",
    AE: "Verenigde Arabische Emiraten",
    GB: "Verenigd Koninkrijk",
    US: "Verenigde Staten",
    UY: "Uruguay",
    UZ: "Oezbekistan",
    VU: "Vanuatu",
    VA: "Vaticaanstad",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis en Futuna",
    EH: "Westelijke Sahara",
    YE: "Jemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  };
  $("#country-list li").each((i, item) => {
    const countryName = $(item).attr("value").trim();
    $(item).text(countryNamesDutch[countryName]);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const isCartPage = BSS_B2B.page.isCartPage();
    if (!isCartPage) return;

    const priceInclEl = document.querySelector(".cart-form__totals .bss-b2b-price-has-vat");
    const priceExclEl = document.querySelector(".cart-form__totals .bss-b2b-price-no-vat");

    if (!priceInclEl || !priceExclEl) return;

    const inclStr = priceInclEl.textContent.trim();
    const exclStr = priceExclEl.textContent.trim();

    const inclValue = Number(inclStr.replace(/[^\d,-]/g, '').replace(',', '.'));
    const exclValue = Number(exclStr.replace(/[^\d,-]/g, '').replace(',', '.'));

    const vatValue = inclValue - exclValue;
    const vatStr = `€${vatValue.toFixed(2).replace('.', ',')}`;

    const vatEl = document.createElement("div");
    vatEl.style.fontSize = "14px";

    const spanLabel = document.createElement("span");
    spanLabel.textContent = "BTW";

    const spanValue = document.createElement("span");
    spanValue.style.marginLeft = "100px";
    spanValue.textContent = vatStr;

    vatEl.appendChild(spanLabel);
    vatEl.appendChild(spanValue);

    const totalsContainer = document.querySelector(".cart-form__totals");
    const subTotalRow = totalsContainer.querySelector(".h-stack.gap-4.justify-between");

    if (subTotalRow && subTotalRow.parentNode) {
      subTotalRow.parentNode.insertBefore(vatEl, subTotalRow.nextSibling);
    }
  }, 2000);
});

